export const doesMapMatch = (prevMarkerStatusMap, nextMarkerStatusMap) => {
  if (prevMarkerStatusMap.size !== nextMarkerStatusMap.size) {
    return false;
  }

  for (let [marker, status] of prevMarkerStatusMap) {
    const nextStatus = nextMarkerStatusMap.get(marker);

    if (nextStatus !== status || nextStatus === undefined) {
      return false;
    }
  }

  return true;
};
